module.exports = require('./src/wordCloud');


//////////////////
// WEBPACK FOOTER
// ./~/echarts-wordcloud/index.js
// module id = 785
// module chunks = 0